export const styles = {
	formControl: {
		marginBottom: '16px',
		minWidth: '100%'
	},
	selectEmpty: {
		marginTop: '16px'
	},
	actions: {
		width: '100%',
		padding: '0 8px',
		marginTop: 8
	},
	mainContainer: {
		display: 'flex'
	},
	memberTypesListWrapper: {
		display: 'flex',
		overflow: 'hidden'
	}
};
